var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext3_1",
    x: 0.726562,
    width: 40,
    height: 40,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M14.7177 18.4079C14.7953 19.2334 14.3554 19.948 13.7407 19.9973C13.126 20.0466 12.5631 19.4182 12.4854 18.5928C12.4078 17.7673 12.8478 17.0527 13.4624 17.0034C14.0771 16.948 14.64 17.5763 14.7177 18.4079Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M18.2407 27.4973C18.8554 27.448 19.2953 26.7334 19.2177 25.9079C19.14 25.0763 18.5771 24.448 17.9624 24.5034C17.3478 24.5527 16.9078 25.2673 16.9854 26.0928C17.0631 26.9182 17.626 27.5466 18.2407 27.4973Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M27.9907 17.0027C28.6054 17.052 29.0453 17.7666 28.9677 18.5921C28.89 19.4237 28.3271 20.052 27.7124 19.9966C27.0978 19.9473 26.6578 19.2327 26.7354 18.4072C26.8131 17.5818 27.376 16.9534 27.9907 17.0027Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M26.7177 22.3421C26.7953 21.5166 26.3554 20.802 25.7407 20.7527C25.126 20.7034 24.5631 21.3318 24.4854 22.1572C24.4078 22.9827 24.8478 23.6973 25.4624 23.7466C26.0771 23.802 26.64 23.1737 26.7177 22.3421Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M23.4907 24.5027C24.1054 24.552 24.5453 25.2666 24.4677 26.0921C24.39 26.9237 23.8271 27.552 23.2124 27.4966C22.5978 27.4473 22.1578 26.7327 22.2354 25.9072C22.3131 25.0818 22.876 24.4534 23.4907 24.5027Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M19.1387 9.83831L12.0973 12.8779C11.9329 12.9516 11.7852 13.0509 11.6551 13.1702C10.8618 13.3672 10.2266 14.0773 10.2266 14.9926V25.6198C10.2266 26.5131 10.755 27.3218 11.5731 27.6805L18.8486 30.8705C19.0715 30.9683 19.2992 31.019 19.5229 31.0287C20.306 31.3238 21.1471 31.3238 21.9303 31.0287C22.1539 31.019 22.3816 30.9683 22.6045 30.8705L29.8801 27.6805C30.6981 27.3218 31.2266 26.5131 31.2266 25.6198V14.9926C31.2266 14.1128 30.6397 13.4226 29.8897 13.1954C29.76 13.0649 29.6078 12.9567 29.4319 12.8779L22.3144 9.83831C21.3101 9.38723 20.1572 9.38723 19.1387 9.83831ZM19.9766 19.1068V29.1533C19.9766 29.4239 19.6988 29.6054 19.451 29.4968L12.1754 26.3067C11.9027 26.1872 11.7266 25.9176 11.7266 25.6198V14.9926C11.7266 14.7203 12.0077 14.5388 12.2559 14.6509L19.0941 17.7398C19.6313 17.9825 19.9766 18.5173 19.9766 19.1068ZM21.4766 29.1533V19.1068C21.4766 18.5173 21.8218 17.9825 22.3591 17.7398L29.1972 14.6509C29.4454 14.5388 29.7266 14.7203 29.7266 14.9926V25.6198C29.7266 25.9176 29.5504 26.1872 29.2777 26.3067L22.0021 29.4968C21.7544 29.6054 21.4766 29.4239 21.4766 29.1533ZM20.7265 13.625C19.4839 13.625 18.4766 13.2892 18.4766 12.875C18.4766 12.4608 19.4839 12.125 20.7265 12.125C21.9692 12.125 22.9766 12.4608 22.9766 12.875C22.9766 13.2892 21.9692 13.625 20.7265 13.625Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice);
export default __webpack_public_path__ + "static/media/Dice.018e86ce.svg";
export { ForwardRef as ReactComponent };